import moment from "moment";

export const _generateDate = (data: Date, culture:string):string => {        
    if(culture === 'Pt')
        return moment(data).format('DD/MM/YYYY');
    else
        return moment(data).format('YYYY-MM-DD');
  };